var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappyFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_468_3327)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 26,
    height: 25,
    rx: 6.25415,
    fill: "#66CDAA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4144 15.2698C12.2817 15.2698 13.7954 13.7561 13.7954 11.8888C13.7954 10.0215 12.2817 8.50781 10.4144 8.50781C8.54714 8.50781 7.03342 10.0215 7.03342 11.8888C7.03342 13.7561 8.54714 15.2698 10.4144 15.2698Z",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9955 11.8886C11.7716 11.8886 12.4007 11.2594 12.4007 10.4834C12.4007 9.70727 11.7716 9.07812 10.9955 9.07812C10.2194 9.07812 9.59024 9.70727 9.59024 10.4834C9.59024 11.2594 10.2194 11.8886 10.9955 11.8886Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44232 13.5052C9.71074 13.5052 9.92833 13.2876 9.92833 13.0192C9.92833 12.7508 9.71074 12.5332 9.44232 12.5332C9.17389 12.5332 8.9563 12.7508 8.9563 13.0192C8.9563 13.2876 9.17389 13.5052 9.44232 13.5052Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0857 15.2698C22.953 15.2698 24.4667 13.7561 24.4667 11.8888C24.4667 10.0215 22.953 8.50781 21.0857 8.50781C19.2184 8.50781 17.7047 10.0215 17.7047 11.8888C17.7047 13.7561 19.2184 15.2698 21.0857 15.2698Z",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 6.95464C17.9054 6.95464 17.7998 6.91238 17.7258 6.83842C17.5884 6.6905 17.5884 6.45806 17.7469 6.3207C18.6556 5.46489 19.8389 5 21.0857 5C22.3113 5 23.4841 5.45432 24.3821 6.28901C24.5301 6.42636 24.5406 6.6588 24.4033 6.80672C24.2659 6.95464 24.0335 6.96521 23.8856 6.82785C23.1248 6.13052 22.1317 5.73959 21.0857 5.73959C20.0291 5.73959 19.0254 6.14109 18.2541 6.85955C18.1907 6.92294 18.0956 6.95464 18.0005 6.95464Z",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5045 11.8886C21.2806 11.8886 21.9098 11.2594 21.9098 10.4834C21.9098 9.70727 21.2806 9.07812 20.5045 9.07812C19.7284 9.07812 19.0993 9.70727 19.0993 10.4834C19.0993 11.2594 19.7284 11.8886 20.5045 11.8886Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0682 13.5052C22.3367 13.5052 22.5542 13.2876 22.5542 13.0192C22.5542 12.7508 22.3367 12.5332 22.0682 12.5332C21.7998 12.5332 21.5822 12.7508 21.5822 13.0192C21.5822 13.2876 21.7998 13.5052 22.0682 13.5052Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 6.95464C13.4044 6.95464 13.3199 6.92294 13.2459 6.85955C12.4746 6.14109 11.4709 5.73959 10.4144 5.73959C9.37892 5.73959 8.38575 6.13052 7.61446 6.82785C7.46654 6.96521 7.23409 6.95464 7.09674 6.80672C6.95939 6.6588 6.96995 6.42636 7.11787 6.28901C8.01595 5.46489 9.18874 5 10.4144 5C11.6611 5 12.8444 5.46489 13.7531 6.3207C13.901 6.45806 13.9116 6.6905 13.7742 6.83842C13.7003 6.92294 13.6052 6.95464 13.4995 6.95464Z",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7712 19.6335C17.3983 19.6335 18.7084 18.3128 18.7084 16.6963H12.8234C12.8339 18.3128 14.1441 19.6335 15.7712 19.6335Z",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6096 18.9888C17.1764 18.5239 16.5214 18.228 15.7712 18.228C15.021 18.228 14.366 18.5239 13.9328 18.9888C14.4399 19.3902 15.0739 19.6333 15.7712 19.6333C16.4685 19.6333 17.1025 19.3902 17.6096 18.9888Z",
    fill: "#EE6F6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_468_3327",
    x: 0.49834,
    y: 0,
    width: 31.0033,
    height: 30.0033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.50166
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_3327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_468_3327",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFace);
export default __webpack_public_path__ + "static/media/happy-face.4e97aa57f0e204843e653e185d5392dd.svg";
export { ForwardRef as ReactComponent };